import { FC, PropsWithChildren } from "react";
import styled from "styled-components";

import {
  DateHelpers,
  IStyledAttributes,
  nowTDateISO,
  useTimezone,
} from "@ryde/shared";
import { redMui, rydeColors } from "@ryde/theme";

interface IDateComparisonProps {
  date: TDateISO;
  originDate?: TDateISO;
  withinDays?: number;
}

interface IStatusStyledProps extends PropsWithChildren {
  isWithin?: boolean;
  isBefore?: boolean;
}

const DateComparisonStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "date-comparison",
})`
  display: flex;
  align-items: center;
  font-weight: 500;
  color: ${rydeColors.black};
`;

const getIsBeforColor = (isBefore?: boolean): string => {
  return isBefore ? rydeColors.lightGreen : redMui._700;
};

const StatusStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "status",
})<IStatusStyledProps>`
  min-width: 14px;
  min-height: 14px;
  border-radius: 50%;
  margin-inline-end: 8px;
  background-color: ${({ isWithin, isBefore }) =>
    isWithin ? rydeColors.orange : getIsBeforColor(isBefore)};
`;

export const DateComparison: FC<IDateComparisonProps> = ({
  date,
  originDate,
  withinDays,
}) => {
  const { timezone } = useTimezone();
  const originDateComputed = originDate || nowTDateISO(timezone);
  const isBefore = DateHelpers.isBefore(originDateComputed, date, timezone);
  const isWithin =
    isBefore && withinDays
      ? DateHelpers.isWithinDays(originDateComputed, date, withinDays, timezone)
      : false;

  return (
    <DateComparisonStyled>
      <StatusStyled isWithin={isWithin} isBefore={isBefore} />
      <span>{date.toString()}</span>
    </DateComparisonStyled>
  );
};
